import React, { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";

const PointCavpCapi = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  useEffect(() => {
    props.CalculRetraite();
  }, [context.state["TableauPoints" + ClientConjoint].RetraiteCompCavpCapi]);
  return (
    <>      {context.state["Carriere" + ClientConjoint].filter((Carriere) => Carriere.Nature === "Cavp").length > 0 && (
        <div className="card">
          <div className="category-column">
            <label className="prise-en-charge-cell-label" style={{ marginBottom: 0 }}>
              CAVP par capitalisation
            </label>
          </div>
          <div className="value-column">
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteCompCavpCapi}
              onChange={(e) => {
                context.handlePointRetraite(ClientConjoint, "RetraiteCompCavpCapi", e);
              }}
              dataType="uint"
              format={{ thousands: " ", decimal: ",", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            31/12/{InitialAnneeAcquisition() + 1}
          </div>
          <div className="value-column">
            <TextField
              value={
                resultRetraite?.InfosRetraite?.Cavp?.General?.CapiCapitalCalcule === undefined
                  ? 0
                  : Number(context.state["TableauPoints" + ClientConjoint].RetraiteCompCavpCapi) + Number(resultRetraite?.InfosRetraite?.Cavp?.General?.CapiCapitalCalcule)
              }
              disabled={true}
              dataType="uint"
              format={{ thousands: " ", decimal: ",", unit: " €" }}
              normal
            />
          </div>
        </div>
      )}
    </>
  );
};
export default PointCavpCapi;
